export default function getSavedState<T>(
  key: string,
  storage: Storage = window.localStorage
): T {
  return JSON.parse(storage.getItem(key) || 'null')
}
